import { Box, Radio, Typography } from '@mui/material';
import { CardInfo } from '../../interfaces/Checkout/CardInfo';
import { TableColumn } from '../../components/DataTable/TableColumn';
import { Installment } from '../../interfaces/Checkout/Installment';
import { PriceColumn } from '../../components/DataTable/PriceColumn';
import { applyRatio } from '../../utils/Currency';
import { DataTable } from '../../components/DataTable/DataTable';

type InstallmentTableProps = {
  cardInfo: CardInfo;
  totalAmount: number;
  selectedInstallment: number;
  onSelect: (installment: number) => void;
};

export const InstallmentTable = ({
  cardInfo,
  totalAmount,
  selectedInstallment,
  onSelect,
}: InstallmentTableProps) => {
  const columns: TableColumn<Installment>[] = [
    {
      id: 'installment',
      name: 'Taksit Sayısı',
      accessor: (row) => (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          <Radio size='small' checked={selectedInstallment === row.value} />

          <Typography sx={{ fontSize: '14px', fontWeight: 600 }}>
            {row.value === 1 ? 'Tek Çekim' : row.value}
          </Typography>
        </Box>
      ),
    },
    {
      id: 'amount',
      name: 'Toplam Ödeme',
      accessor: (row) => (
        <PriceColumn value={applyRatio(totalAmount, row.ratio)} />
      ),
    },
  ];

  return (
    <DataTable
      columns={columns}
      totalCount={cardInfo.installmentOptions.length}
      rows={cardInfo.installmentOptions}
      hidePagination
      onClick={(row) => onSelect(row.value)}
    />
  );
};
